import { useQuery } from "@tanstack/react-query";
import { usePathname } from "next/navigation";

import api from "../api";
import { useUser } from "../contexts/user";
import { QUERY_KEYS, ROUTE_PREFIX } from "../constants";

const client = api();
const ALLOWED_ROUTE_PREFIXES = Object.values(ROUTE_PREFIX).filter(
  (path) =>
    ![
      ROUTE_PREFIX.FIVE_HUNDRED,
      ROUTE_PREFIX.FOUR_O_FOUR,
      ROUTE_PREFIX.NEWSLETTER_SIGNUP,
      ROUTE_PREFIX.TROPHIES,
    ].includes(path),
);

function getRoutePrefix(pathname) {
  // Remove leading/trailing slashes and split
  const segments = pathname.replace(/^\/+|\/+$/g, "").split("/");
  // Get first non-empty segment or return "/" for root
  const firstSegment = segments.find(Boolean) || "/";

  return firstSegment;
}

export default function useOnSiteMessagesQuery(
  { contentType, contentId },
  options = {},
) {
  const pathname = usePathname();
  const { user } = useUser();

  const routePrefix = getRoutePrefix(pathname);
  const {
    data: onSiteMessages,
    isLoading: isOnSiteMessagesLoading,
    isError: onSiteMessagesError,
  } = useQuery({
    queryKey: [QUERY_KEYS.ON_SITE_MESSAGES, contentType, contentId],
    queryFn: () => client.getOnSiteMessagesV2(contentType, contentId),
    enabled: ALLOWED_ROUTE_PREFIXES.includes(routePrefix),
    ...options,
  });

  if (user.features.v2OnSiteMessagesOn) {
    return {
      onSiteMessages,
      isOnSiteMessagesLoading,
      onSiteMessagesError,
    };
  }

  return {
    onSiteMessages: user.onSiteMessages,
    isOnSiteMessagesLoading: false,
    onSiteMessagesError: null,
  };
}
